<kodit-page [showCardBlock]="showCardBlock">
  <kodit-table
    [tableConfig]="tableConfig"
    [items]="poslovneJedinicaTable"
    [isTableLoading]="isLoading"
  ></kodit-table>
</kodit-page>
